<template>
  <el-dialog title="知识详情"
             width="60%"
             :visible.sync="dialogFormVisible"
             :before-close="handleClose"
             append-to-body>
    <div class="header">
      <el-row class="title">
        {{knowledgeData.TITLE}}
      </el-row>
      <el-row type="flex"
              class="author"
              align="bottom"
              :gutter="20">
        <el-col :span="12">
          <ul>
            <li>{{knowledgeData.CREATEUSERNAME}}</li>
            <li>{{knowledgeData.CREATETIME|timeFormater}}</li>
            <li>{{knowledgeData.SOURCE|sourceFormater}}</li>
          </ul>
        </el-col>

        <el-col :span="12">
          <ul>
            <li>
              <span title="点赞"
                    @click.stop="upvote"
                    :class="knowledgeData.IsUpvote?'add':'del'">
                <i class="icon iconfont icon-zan1"></i>
              </span>
              {{knowledgeData.UpvoteCount}}
            </li>
            <li><span title="收藏"
                    @click.stop="focus"
                    :class="knowledgeData.IsFocus?'add':'del'"><i class="icon iconfont icon-pingjia"></i> </span> {{knowledgeData.FocusCount}}</li>
            <li><span title="阅读"><i class="icon iconfont icon-yuedu"></i></span> {{knowledgeData.ReadCount}}</li>
            <li><span title="评价"><i class="icon iconfont  icon-shoucang-"></i></span> {{knowledgeData.EvalutionCount}}</li>
            <li>
              <el-dropdown>
                <span title="分享"
                      class="share"><i class="el-icon-share"> 分享</i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-share"
                                    v-clipboard:copy="shareUrl"
                                    @click.native="shareKnowledge">复制链接 </el-dropdown-item>
                  <el-dropdown-item>
                    <div style="popover-div">
                      <span title="二维码"
                            style="display:block"><i class="el-icon-picture"> 二维码扫一扫</i> </span>
                      <img class="img"
                           :src="qrcode" />
                    </div>
                  </el-dropdown-item> 
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-popover placement="bottom"
                          width="200"
                          trigger="hover">
                <div style="popover-div">
                  <span title="复制链接"
                        v-clipboard:copy="shareUrl"
                        class="share"
                        @click.stop="shareKnowledge"><i class="el-icon-share"> 复制链接</i> </span>
                  <span title="二维码"><i class="el-icon-picture"> 二维码</i> </span>
                  <img class="img"
                       :src="convertQRcode(knowledgeData.ID)" />
                </div>
                <span title="分享"
                      slot="reference"
                      class="share"><i class="el-icon-share"> 分享</i> </span>
              </el-popover> -->
              <!-- <el-button type="text"
                         v-clipboard:copy="shareUrl"
                         @click="shareKnowledge"><i class="el-icon-share"></i>分享</el-button> -->
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row class="knowledgecontent"
              v-html="knowledgeData.BODY">
      </el-row>
      <el-row class="tagPanel">
        <span style="margin: auto 0">关键词:</span>
        <ul>
          <li v-for="item in knowledgeData.Tags"
              :key="item.ID">
            <el-tag>{{ item.TAGNAME }}</el-tag>
          </li>
        </ul>
      </el-row>
      <el-row class="filePanel">
        <fileListView :fileList="fileList"></fileListView>
      </el-row>
    </div>
    <div>
      <el-row class="commentInput"
              type="flex"
              :gutter="20"
              v-show="showCommentInput==true">
        <el-col :span="20">
          <el-input type="textarea"
                    :rows="2"
                    v-model="commentContent"
                    placeholder="请输入内容">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary"
                     @click="addComment">添加评论</el-button>
        </el-col>
      </el-row>
      <ul>
        <li class="commentDiv"
            v-for="item in commentList"
            :key="item.id">
          <el-row type="flex"
                  :gutter="20">
            <el-col class="userName">
              {{ item.CREATEUSERNAME }}
            </el-col>
            <el-col class="createTime">
              {{ item.CREATETIME|timeFormater }}
            </el-col>
          </el-row>
          <span class="commentContent"> {{item.CONTENT}}</span>
        </li>
      </ul>

    </div>
  </el-dialog>
</template>

<script>
import { getQRcode } from "@/api/modules/basicData/commonData.js";
import {
  AddKnowledgeComment,
  GetKnowlegeBody,
  IsFocus,
  IsUpVote,
  GetKnowledgeCommentByMainId,
  AddReadRecord,
  DelKnowledgeFocus,
  AddKnowledgeFocus,
  DeleteKmUpVote,
  
  AddKmUpVote
} from "@/api/modules/basicData/knowledge";
import {GetFileInfoByTaskId} from   "@/api/modules/basicData/task.js";
import fileListView from "../../components/common/fileListView.vue";
import { getToken } from "../../util/auth";
const cookieUser = getToken();
export default {
  props: {
    knowledgeData: {
      type: Object,
      default: {}
    },
    showComment: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      commentContent: "",
      fileList: [],
      commentList: [],
      shareUrl: "",
      showCommentInput: true,
      qrcode: "",
    };
  },
  created() {
    this.setProps();
  },
  methods: {
    shareKnowledge() {
      this.$message({
        message: "知识链接已复制,请粘贴到地址栏访问",
        type: "success"
      });
      // this.$alert(
      //   `<a href="${location.href + otherKnowledge.ID}">${
      //     otherKnowledge.NAME
      //   }</a>`,
      //   "知识链接",
      //   {
      //     dangerouslyUseHTMLString: true
      //   }
      // );
    },
    setProps() {
      this.showCommentInput = this.showComment;
    },
    handleClose() {
      this.dialogFormVisible = false;
    },
    upvote() {
      if (this.knowledgeData.IsUpvote) {
        DeleteKmUpVote(this.knowledgeData.ID).then(result => {
          if (result > 0) {
            this.knowledgeData.IsUpvote = false;
            this.knowledgeData.UpvoteCount--;
          }
        });
      } else {
        AddKmUpVote({
          MAINID: this.knowledgeData.ID,
          MAINTYPE: 0,
          UPVOTEUSERID: cookieUser.userId,
          UPVOTEUSERNAME: cookieUser.realName
        }).then(result => {
          if (result > 0) {
            this.knowledgeData.IsUpvote = true;
            this.knowledgeData.UpvoteCount++;
          }
        });
      }
    },
    focus() {
      if (this.knowledgeData.IsFocus) {
        DelKnowledgeFocus(this.knowledgeData.ID).then(result => {
          if (result > 0) {
            this.knowledgeData.IsFocus = false;
            this.knowledgeData.FocusCount--;
          }
        });
      } else {
        AddKnowledgeFocus({
          KNOWLEDGEID: this.knowledgeData.ID,
          USERID: cookieUser.userId,
          DEPTID: cookieUser.departmentId,
          COMPANYID: cookieUser.companyId
        }).then(result => {
          if (result > 0) {
            this.knowledgeData.IsFocus = true;
            this.knowledgeData.FocusCount++;
          }
        });
      }
    },
    addComment() {
      if (!this.commentContent) {
        this.$message.warning("请填写评论");
        return;
      }
      AddKnowledgeComment({
        CONTENT: this.commentContent,
        CREATEUSERID: cookieUser.userId,
        CREATEUSERNAME: cookieUser.realName,
        CREATEDEPTID: cookieUser.departmentId,
        CREATEDEPTNAME: cookieUser.departmentName,
        MAINID: this.knowledgeData.ID,
        MAINTYPE: 0,
        CREATECOMPANYID: cookieUser.companyId,
        CREATECOMPANYNAME: cookieUser.companyName
      }).then(result => {
        if (result > 0) {
          this.commentContent = "";
          GetKnowledgeCommentByMainId(this.knowledgeData.ID).then(result2 => {
            if (result2) {
              this.commentList = result2;
            }
          });
        }
      });
    }
  },
  watch: {
    knowledgeData(newValue, oldValue) {
      if (newValue.hasOwnProperty("IsUpvote") === false) {
        newValue.IsUpvote = false;
      }
      if (newValue.hasOwnProperty("IsFocus") === false) {
        newValue.IsFocus = false;
      }

      this.shareUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/knowledgeShare/${newValue.ID}`;

      getQRcode(this.shareUrl, 150, 150).then(result => {
        console.log(result);
        if (result) this.qrcode = result;
      });
      if (newValue.hasOwnProperty("IsRead") === false) {
        newValue.IsRead = false;
        //添加查看记录
        AddReadRecord({
          KNOWLEDGEID: newValue.ID,
          USERID: cookieUser.userId,
          USERNAME: cookieUser.realName,
          DEPTID: cookieUser.departmentId,
          DEPTNAME: cookieUser.departmentName
        }).then(result => {
          if (result > 0) {
            newValue.IsRead = true;
          }
        });
      }
      //获取内容
      GetKnowlegeBody(newValue.ID).then(result => {
        if (result) {
          newValue.BODY = result.m_Item1;
        }
      });
      //是否关注过
      IsFocus(newValue.ID).then(result => (newValue.IsFocus = result));
      //是否点赞过
      IsUpVote(newValue.ID).then(result => {
        newValue.IsUpvote = result;
      });
      //获取知识评论
      GetKnowledgeCommentByMainId(newValue.ID).then(result => {
        if (result) {
          this.commentList = result;
        }
      });

      //获取附件
      if (!newValue.Files)
         GetFileInfoByTaskId(newValue.ID, 30).then(result => {
          if (result) {
            newValue.Files = result;
             this.fileList = JSON.parse(JSON.stringify(newValue.Files));
                this.fileList.forEach(c => {
        c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
      });
          }
         });
         else{
  console.log("files",newValue.Files);
      this.fileList = JSON.parse(JSON.stringify(newValue.Files));
      this.fileList.forEach(c => {
        c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
      });
         }
    
    }
  },

  filters: {
    sourceFormater: function(value) {
      switch (value) {
        case 0:
          return "主动添加";
        case 1:
          return "事件单或解决方案提交";
        case 2:
          return "问题单或解决方案提交";
        case 3:
          return "发布实施结果提交";
        case 4:
          return "服务目录相关内容共享";
      }
    }
  },
  components: {
    fileListView
  }
};
</script>

<style scoped>
.title {
  text-align: left;
  font-weight: bold;
  font-size: 28px;
}
.author {
  color: #606266;
  margin-top: 17px;
  padding-bottom: 5px;
  border-bottom: 1px dashed gray;
}
.header {
  border-bottom: 1px dashed #606266;
}
.tagPanel {
  display: flex;
  margin-bottom: 5px;
  color: #929292;
}
.filePanel {
  margin-bottom: 5px;
}
.el-switch__core {
  display: none !important;
}
.knowledgecontent {
  text-align: left;
  margin: 34px 5px;
  color: #474747;
}
.add {
  color: #ff5400;
  cursor: pointer;
}
.del {
  color: #939393;
  cursor: pointer;
}
.share {
  color: #409eff;
  cursor: pointer;
  font-weight: bold;
}
.header li {
  float: left;
  margin: auto 5px;
}

.commentInput {
  margin: 10px;
  align-items: center;
}
.commentDiv {
  margin: 5px 0;
}
.userName {
  width: auto;
  margin: auto 0;
  font-weight: bolder;
  color: #409eff;
}
.createTime {
  width: auto;
  margin: auto 0;
  color: #909399;
}
.commentContent {
  margin: 5px 0;
  width: auto;
  color: #3a3a3a;
  text-align: left;
}
.el-dialog__body {
  padding: 10px 20px;
}
.popover-div {
  text-align: center;
  margin: 0;
  cursor: default;
}
</style>